import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import g from './global';

const getY = (x0, x1, x, min = 0, max = 1) => {
  return (-min*x + max*x - max*x0 + min*x1) / (x1 - x0);
}

const myLimit2 = (progress, zero1, center1, center2, zero2) => {
  if (progress <= zero1) {
    return 0.5
  } 
  if (progress <= center1) {
   return getY(zero1, center1, progress, 0.5)
 } 
  if (progress > center1 && progress < center2) {
   return 1
 } 
 if (progress <= zero2) {
   return getY(zero2, center2, progress, 0.5)
 }
 return 0.5
}

const labSection = document.querySelector('.js-section-lab');
const labSlider = document.querySelector('.js-lab-slider');
const labSlideNodes = [...labSlider.querySelectorAll('.js-item')];

const updateForMobile = (progress) => {
  const scrollWidth = labSlider.scrollWidth - window.innerWidth;
  let sumWidth = 0;
  const half = (window.innerWidth/2) / scrollWidth;
  labSlideNodes.forEach((slide, i) => {
    const width = slide.offsetWidth / scrollWidth;
    const center = sumWidth + width/2 - half;
    const zero1 = center - half;    
    const center1 = center - half/2; 
    const center2 = center + half/2 ; 
    const zero2 = center + half ;
    
    sumWidth += width;

    let opacity = myLimit2(progress, zero1, center1, center2, zero2);
    const img = slide.querySelector('img');

    if (
      progress >= center2 && i === labSlideNodes.length-1
      || progress <= center1 && i === 0
    ) {
      opacity = 1;
    }

    img.style.opacity = opacity;
  })
}

const updateForDesk = progress => {
  const scrollHeight = labSlider.scrollHeight - window.innerHeight;
  let sumHeight = 0;
  const half = (window.innerHeight/2) / scrollHeight;
  const header = document.querySelector('.js-header').offsetHeight / scrollHeight || 0;
  labSlideNodes.forEach((slide, i) => {
    const height = slide.offsetHeight / scrollHeight;
    const center = sumHeight + height/2 - half - header;
    const zero1 = center - half;
    const center1 = center - half/2; 
    const center2 = center + half/2 ; 
    const zero2 = center + half ;

    sumHeight += height;

    let opacity = myLimit2(progress, zero1, center1, center2, zero2);
    const img = slide.querySelector('img');

    if (
      progress >= center2 && i === labSlideNodes.length-1
      || progress <= center1 && i === 0
    ) {
      opacity = 1;
    }

    img.style.opacity = opacity;
  })
}

const labUpdate = progress => {
  if (!g.isMobile) { updateForDesk(progress) } else { updateForMobile(progress) }
}

let labTl;
const createLabTimeline = () => {
  if (!g.isMobile) {
    return gsap.timeline({
      scrollTrigger: {
        id: 'triggerLab',
        trigger: labSection,
        pin: true,
        scrub: 0,
        scroller: '[data-scroll-container]',
        end: () => `+=${labSlider.scrollHeight - window.innerHeight}`,
      },
      onUpdate: () => { labUpdate(labTl.progress()) }
    })
    .to(labSlider, {
      y: () => `-=${labSlider.scrollHeight - window.innerHeight}`,
      ease: 'none',
    }, 0)
  }
  return gsap.timeline({
    scrollTrigger: {
      id: 'triggerLab',
      trigger: labSection,
      pin: true,
      scrub: 0,
      start: 'bottom bottom',
      scroller: '[data-scroll-container]',
      end: () => `+=${labSlider.scrollWidth - window.innerWidth}`,
    },
    onUpdate: () => { labUpdate(labTl.progress()) }
  })
  .to(labSlider, {
    x: () => `-=${labSlider.scrollWidth - window.innerWidth}`,
    ease: 'none',
  }, 0)
}

const slider = {
  init: () => {
    labTl = createLabTimeline();
    labUpdate(0);
    ScrollTrigger.refresh();
  },
  resize: () => {
    if (ScrollTrigger.getById('triggerLab')) {
      const progress = labTl.progress();
     
      gsap.set([labSlider, labSection], {clearProps: 'all'});
      ScrollTrigger.getById('triggerLab').kill(true);
      
      labTl = createLabTimeline();
      labUpdate(progress);
      labTl.progress(progress);
    }
  }
}

export default slider;



